export default function (value, decimals, keepTrailingZeroes = false) {
	let result;
	if (("" + value).indexOf("e") > 0) {
		result = value.toFixed(decimals);
	}
	else {
		result = Number(Math.round(value + "e" + decimals) + "e-" + decimals);
	}
	if (!keepTrailingZeroes) {
		return result;
	}

	let resultStr = "" + result;
	while (resultStr.substr(resultStr.indexOf(".") + 1).length < decimals) {
		resultStr += "0";
	}
	return resultStr;
}
